import React, { useRef, SVGProps } from "react";
import useWindowDimensions from "@/common/hooks/useWindowDimension";
import { clsx } from "clsx";
import { PopOverMenuList } from "./PopOverMenuList";
import { SwipePopup } from "@/components/popups/SwipePopup";
import { PopOverMenuCanvas } from "./PopOverMenuCanvas";
import "./style/PopOverMenu.scss";
import { useBodyLock } from "@/common/hooks/useBodyLock";

export interface IGroup {
  groupName: string | null | (() => React.ReactNode);
  groupMobileName: string | null | (() => React.ReactNode);
  className?: string;
  items: IItem[];
}

export interface IItem {
  title: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

interface IPopOverMenuProp {
  anchorEl: Element | null;
  isOpen: boolean;
  onClose: () => void;
  menuItems: IGroup[];
  className?: string;
  title?: string;
}

export const PopOverMenu = (props: IPopOverMenuProp) => {
  const { isOpen, onClose, menuItems, anchorEl, className, title } = props;
  const fullScreenMenuRef = useRef(null);
  const isDesktop = useWindowDimensions();

  useBodyLock(true);

  const closeFullScreenMenu = (e: React.MouseEvent) => {
    if (fullScreenMenuRef.current === e.target) {
      onClose();
    }
  };

  return (
    <div
      className={clsx(["PopOverMenu", className])}
      ref={fullScreenMenuRef}
      onClick={closeFullScreenMenu}
    >
      {!isDesktop ? (
        <SwipePopup
          isOpen={isOpen}
          onClose={onClose}
          title={title}
        >
          <div className="MoreMenuPopupCnt">
            {menuItems.map((group: IGroup, index: number) => (
              <PopOverMenuList {...group} key={index}/>
            ))}
          </div>
        </SwipePopup>
      ) : (
        <PopOverMenuCanvas onClose={onClose} anchorEl={anchorEl}>
          {menuItems.map((group: IGroup, index: number) => (
            <PopOverMenuList {...group} key={index}/>
          ))}
        </PopOverMenuCanvas>
      )}
    </div>
  );
};
